import { de as translationsDe } from '../i18n-assets/de';
import { nl as translationsNl } from '../i18n-assets/nl';

export const uigI18nOverrides = {
  de: translationsDe,
  nl: translationsNl,
};